"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatLoginButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_1 = require("../../../components/modal");
const ChatLoginButton = () => {
    const loginModalUser = (e) => {
        if (!(e.target instanceof HTMLButtonElement)) {
            return;
        }
        (0, modal_1.showLoginModal)();
    };
    return ((0, jsx_runtime_1.jsx)("button", { className: "loadLoginModal", onClick: (e) => loginModalUser(e), children: "Login" }));
};
exports.ChatLoginButton = ChatLoginButton;
